import { jsx } from 'react/jsx-runtime';
import 'luxon';
import 'react';
import 'styled-components';
import '../../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../../../theme/ThemedComponentWrapper.js';
import 'ethereum-blockies-base64';
import '../../../icons/ActivityIcon.js';
import '../../../icons/ArrowDownIcon.js';
import '../../../icons/ArrowDownRightCircleIcon.js';
import '../../../icons/ArrowLeftAlignIcon.js';
import '../../../icons/ArrowLeftIcon.js';
import '../../../icons/ArrowRightAlignIcon.js';
import '../../../icons/ArrowRightIcon.js';
import '../../../icons/ArrowSwitchIcon.js';
import '../../../icons/ArrowUpIcon.js';
import '../../../icons/ArrowUpRightCircleIcon.js';
import '../../../icons/ArrowsAngleExpandIcon.js';
import '../../../icons/BankIcon.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/ChevronDownIcon.js';
import '../../../icons/ChevronRightIcon.js';
import '../../../icons/ChevronUpIcon.js';
import '../../../icons/CopyIcon.js';
import '../../../icons/CrossIcon.js';
import '../../../icons/DaiIcon.js';
import '../../../icons/DangerIcon.js';
import '../../../icons/DownSortIcon.js';
import '../../../icons/ExclamationTriangleIcon.js';
import '../../../icons/ExpandKpiIcon.js';
import '../../../icons/EyeIcon.js';
import '../../../icons/EyeSlashIcon.js';
import '../../../icons/Grid1x2Icon.js';
import '../../../icons/InfoCircleIcon.js';
import '../../../icons/ListIcon.js';
import '../../../icons/LockIcon.js';
import '../../../icons/MediumIcon.js';
import '../../../icons/MoonIcon.js';
import '../../../icons/PiggyBankIcon.js';
import '../../../icons/QuestionMarkCircleIcon.js';
import '../../../icons/ShieldIcon.js';
import '../../../icons/SunIcon.js';
import '../../../icons/UpSortIcon.js';
import '../../../icons/XIcon.js';
import '../../../icons/InfinityIcon.js';
import '../../../icons/ArrowUpRightBoxIcon.js';
import '../../../atoms/layout/Stack/Stack.js';
import '../../../atoms/Table/components/Pagination/Pagination.js';
import '../../../atoms/Table/Table.js';
import '../../../atoms/ToggleSwitch.js';
import '@floating-ui/react';
import '../../../atoms/Tooltip/components/TooltipContext.js';
import '../../../molecules/CurrencyValue/components/Value.js';
import '../../../molecules/KpiCard/KpiCard.js';
import '../../../molecules/PercentageValue.js';
import '../../../molecules/Tabs/Tabs.js';
import '../../../molecules/TrendValue.js';
import '../../../pictograms/EthPictogram.js';
import '../../../pictograms/EtherScanPictogram.js';
import '../../../pictograms/DebankPictogram.js';
import '../../../pictograms/ZapperPictogram.js';
import '../../../pictograms/DaiPictogram.js';
import '../../../molecules/Modal/Modal.js';
import '../../ChartKpis/ChartKpi.js';
import '../../ChartJS.js';
import '../Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../../XRay.js';

function HeatmapRowLabel({ children, ...rest }) {
    return (jsx(ThemedComponentWrapper, { ...rest, name: "heatmapRowLabel", children: children }));
}

export { HeatmapRowLabel as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhdG1hcFJvd0xhYmVsLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jaGFydHMvSGVhdG1hcC9jb21wb25lbnRzL0hlYXRtYXBSb3dMYWJlbC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVGhlbWVkQ29tcG9uZW50V3JhcHBlciB9IGZyb20gJ0BpbmRleCc7XG5pbXBvcnQgeyBUaGVtZWRDb21wb25lbnRXcmFwcGVyUHJvcHMgfSBmcm9tICcuLi8uLi8uLi8uLi90aGVtZS9UaGVtZWRDb21wb25lbnRXcmFwcGVyJztcblxuaW50ZXJmYWNlIEhlYXRtYXBSb3dMYWJlbFByb3BzXG4gIGV4dGVuZHMgT21pdDxUaGVtZWRDb21wb25lbnRXcmFwcGVyUHJvcHM8J3RyJz4sICduYW1lJz4ge31cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gSGVhdG1hcFJvd0xhYmVsKHtcbiAgY2hpbGRyZW4sXG4gIC4uLnJlc3Rcbn06IEhlYXRtYXBSb3dMYWJlbFByb3BzKSB7XG4gIHJldHVybiAoXG4gICAgPFRoZW1lZENvbXBvbmVudFdyYXBwZXIgey4uLnJlc3R9IG5hbWU9XCJoZWF0bWFwUm93TGFiZWxcIj5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L1RoZW1lZENvbXBvbmVudFdyYXBwZXI+XG4gICk7XG59XG4iXSwibmFtZXMiOlsiX2pzeCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBTWMsU0FBVSxlQUFlLENBQUMsRUFDdEMsUUFBUSxFQUNSLEdBQUcsSUFBSSxFQUNjLEVBQUE7QUFDckIsSUFBQSxRQUNFQSxHQUFBLENBQUMsc0JBQXNCLEVBQUEsRUFBQSxHQUFLLElBQUksRUFBRSxJQUFJLEVBQUMsaUJBQWlCLEVBQUEsUUFBQSxFQUNyRCxRQUFRLEVBQUEsQ0FDYztBQUU3Qjs7OzsifQ==
